export const VIEW = 'view';
export const CREATE = 'create';
export const UPDATE = 'update';
